/**
 * „Stammplatz geändert – Etikett auf dem Gerät prüfen.“ (Rückmeldungen 4.4)
 *
 * Die App merkt sich nicht, welche Etiketten gedruckt wurden. Sobald sich ein
 * Stammplatz ändert, steht deshalb dieser Hinweis in der Rückmeldung, kein
 * Popup. Der Knopf öffnet die Druckansicht mit genau den geänderten Geräten;
 * einzelne lassen sich dort wieder abwählen. Ein Packstück druckt sein
 * Lagerort-Etikett, alles andere das Geräte-Etikett.
 */

import { Link } from "react-router";
import type { Bestand } from "../lokal/bestand.js";
import { ortDesArtikels } from "../lokal/verschieben.js";

/** Die Adresse der Druckansicht mit diesen Geräten vorgewählt. */
export function etikettenAdresse(bestand: Bestand, artikel_ids: readonly string[]): string {
  const parameter = new URLSearchParams();
  for (const id of artikel_ids) {
    const ort = ortDesArtikels(bestand, id);
    if (ort === null) parameter.append("artikel", id);
    else parameter.append("lagerort", ort.id);
  }
  return `/etiketten?${parameter.toString()}`;
}

export function EtikettHinweis({
  bestand,
  artikel_ids,
}: {
  bestand: Bestand;
  artikel_ids: readonly string[];
}) {
  if (artikel_ids.length === 0) return null;
  return (
    <span className="mt-2 flex flex-col gap-2" data-testid="etikett-hinweis">
      <span className="font-semibold">Stammplatz geändert – Etikett auf dem Gerät prüfen.</span>
      <Link
        to={etikettenAdresse(bestand, artikel_ids)}
        className="flex min-h-12 items-center justify-center rounded-xl border-2 border-current px-4 font-semibold active:opacity-70"
      >
        {artikel_ids.length === 1 ? "Etikett drucken" : "Etiketten drucken"}
      </Link>
    </span>
  );
}
